export enum Environment {
  DEV = 'development',
  STAGING = 'staging',
  PROD = 'production',
}
